import React, { useEffect, useState } from 'react'
import { ModalBody, ModalHeader } from 'react-bootstrap'
import Modal from "react-bootstrap/Modal";
import Buttons from '../../../../Components/UI/Buttons';
import FormInputFields from '../../../../Components/FormInputFields';
import SwitchItems from '../../../../Components/FormBuilder/Builder/FormInputs/SwitchItems';
import { ErrorBlock } from '../../../../hoc/FormInput';
import { isSet } from '../../../../Utils/CommonFunctions';

const GroupEditForm = (props) => {
    const [ validation,setvalidation]=useState({});
    const buttonList=[  {
        attributes:{
        className:"btn border-default btn-border mr-2 cursor-pointer",
        },
        clickHandler:()=>props.closePopupToogle(),
        name:"Cancel"
    },  
    {
    attributes:{
        className:"btn primary_bg cursor-pointer"
    },
    clickHandler:()=>validateForm(),
    name:"Save"
}]
const field={
        type:'PickList',
        label:'Package Type',
        isDefault:true,
        violation_name:'type',
        value:props.payload.type,
        options: [
            { value: '-None-', id: '' },
            ...props.Fields
                .filter(item => item.access_mode !== "HIDDEN") // remove hidden
                .map(item => ({
                    value: item.label.blocks[0].text,
                    id: item.id
                }))
        ],
            attributes:{
                className:'form-control mandatory',
            },
            changeHandler:(val)=>fieldChangeHandler(val),
}

    const validateForm = () => {
        const { payload } = props;
        const newValidation = {};
        let isBasicError = false;
        if (!payload?.type?.trim()) {
            isBasicError = true;
            newValidation.type = "Package Type is required";
        }
        if (!payload?.value) {
            isBasicError = true;
            newValidation.value = "Value is required";
        }
        if (payload?.value) {
            if (typeof payload.value === "object" && payload.value !== null) {
                if (!payload.value.displayValue) {
                    isBasicError = true;
                    newValidation.value = "Value is required";
                }
            }
        }
        setvalidation(newValidation);
        if (!isBasicError) {
            props.saveHandler()
        }
    }
    useEffect(() => {
        if (validation.value) {
            setvalidation((prev) => ({
                ...prev,
                value: ""
            }));
        }
    }, [props.payload.value]);
    useEffect(() => {
        props.updatePayload({ ...props.payload, value: "" })
        const elementType = fieldObj?.item?.element;
        if(elementType==="PickList"){
            props.changeHandler(fieldObj,"" ,'PickList')
        }
        if (validation.value) {
            setvalidation((prev) => ({
                ...prev,
                value: ""
            }));
        }
    }, [props.payload.type])

    const fieldChangeHandler = (val) => {
        props.updatePayload({ ...props.payload, type: val })
        setvalidation((prev) => (
            {
                ...prev,
                type: ""
            })
        )
    }
const fieldObj = {
    section_index: 0,
    itemIndex: 0,
    modType:'ADDFORM',
    formType: "SUBFORM",
    item: props.item,
    rowIndex:0,
    subFormIndex:0,
    columnIndex:0
  };
  return (
    <Modal size="md" show={true} style={{ zIndex: 1050 }}  >
    <Modal.Header >
    <h4 className="nav nav-pills navcrm-primary nav-pills-no-bd">Group Edit</h4>
    </Modal.Header>
    <Modal.Body>
    <div className="form-group">
        <label> Package </label>
        <div className='input-group'>
        <FormInputFields {...field} />
        </div>
        <ErrorBlock message={isSet(validation.type,"")} />
        </div>
        <div className="form-group">
        <label> Value </label>
        <div className='input-group'>
             <SwitchItems
                       {...props}
                       layoutForms={true}
                       formType={'SUBFORM'}
                       modType={'ADDFORM'}
                       fieldObj={fieldObj}
                       item={props.item}
                       onChangeInputAction={props.changeHandler}
                       reminderDisplayText={props.reminderDisplayText}
                     />
        {/* <FormInputFields {...value} /> */}
        </div>
        <ErrorBlock message={isSet(validation.value,"")} />
        </div>
    </Modal.Body>
    <Modal.Footer>

    <Buttons buttonList={buttonList} />
  
    </Modal.Footer>
    </Modal>
  )
}

export default GroupEditForm